/* eslint no-unused-vars: 0 */

const DEBUG = process.env.NODE_ENV === 'development'
const DOMAIN_ROOT = location.origin

export const S3_BUCKET_NAME = 'classforward'
export const GOOGLE_ANALYTICS_ID = 'UA-78079791-2'
export const SENTRY_URL = 'https://80ed850ce2154364b9f9e6bff895d906@sentry.io/177277'

export const OAUTH_GOOGLE_CLIENT_ID = process.env.OAUTH_GOOGLE_CLIENT_ID
export const OAUTH_MICROSOFT_CLIENT_ID = process.env.OAUTH_MICROSOFT_CLIENT_ID
export const OAUTH_CLEVER_CLIENT_ID = process.env.OAUTH_CLEVER_CLIENT_ID

const OAuthGoogleLoginRedirectURI = `${DOMAIN_ROOT}/accounts/google/login/callback/`
const OAuthGoogleConnectRedirectURI = `${DOMAIN_ROOT}/accounts/google/connect/`

export const OAuthGoogleLoginURL = `https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=${OAUTH_GOOGLE_CLIENT_ID}&redirect_uri=${OAuthGoogleLoginRedirectURI}&scope=profile+email`
export const OAuthGoogleConnectURL = `https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=${OAUTH_GOOGLE_CLIENT_ID}&redirect_uri=${OAuthGoogleConnectRedirectURI}&scope=profile+email`

export const OAuthMicrosoftConnectURL = ''
export const OAuthMicrosoftLoginURL = ''

export const OAuthCleverConnectURL = ''
export const OAuthCleverLoginURL = ''



// WEBPACK FOOTER //
// ./src/settings.js